
  <div class="border-div" style="margin-top:30px">
    <div class="floatinghead floatinghead-xs clearfix">
      <div class="row">
        <div class="col-sm-3 cf">
          <h2 class="mainhead d-flex"><span class="text">Prospects</span></h2>
        </div>
      </div>
      <div class="table-responsive table-v-scroll table-fixed import-prospect-table" style="width: 100%">
        <table id="openro-data" class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th [hidden]="true" data-orderable="false"></th>
              <th>Prospect</th>
              <th>Date</th>
              <th>Company</th>
              <th>OM</th>
              <th>NDA</th>
              <th class="min-width-75">Property<br />/Portfolio</th>
              <th>Status</th>
              <th>Feedback</th>
              <th data-orderable="false">Notes</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="lstProspects?.length > 0">
              <ng-container *ngFor="let prospects of lstProspects;let i = index;">
                <tr>
                  <td [hidden]="true"></td>
                  <td>
                    <p>
                      <a href="#" target="_blank" routerLink="/prospect-detail/" [queryParams]="{prospectId:prospects.ProspectMasterId,prevroute:'Property Details',link:router.url}">
                        {{prospects.ProspectName}}
                      </a>
                    </p>
                  </td>
                  <td class="whitespacenowrap">
                    <p class="d-flex">
                      {{prospects.ModifiedDate ? ( prospects.ModifiedDate | date:'MM/dd/yyyy') : '-'}}
                    </p>
                  </td>
                  <td>{{prospects.CompanyName != null && prospects.CompanyName.length > 0 ?prospects.CompanyName : "Private" }}</td>
                  <td style="padding-bottom:34px">
                    <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxOMDownloads_{{i+1}}">
                      <input [disabled]="true" type="checkbox" [(ngModel)]="prospects.OMDownloads" id="checkboxOMDownloads_{{i+1}}">
                      <i></i>
                    </label>
                  </td>
                  <td style="padding-bottom:34px">
                    <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted_{{i+1}}">
                      <input [disabled]="true" type="checkbox" [(ngModel)]="prospects.NDAExecuted" id="checkboxNDAExecuted_{{i+1}}">
                      <i></i>
                    </label>
                  </td>
                  <td>
                    {{prospects.OfferOn}}
                  </td>
                  <td>
                    {{prospects.StatusName != null && prospects.StatusName.length > 0 ? prospects.StatusName : "-"}}
                  </td>
                  <td>
                    {{prospects.FeedbackName != null && prospects.FeedbackName.length > 0 ? prospects.FeedbackName : "-"}}
                  </td>
                  <td>
                    <p class="td-note" *ngIf="showNotes" style="max-width:120px;min-width:120px;">
                      {{prospects.Notes ? prospects.Notes : '-'}}
                    </p>
                  </td>

                </tr>
              </ng-container>
            </ng-container>

          </tbody>
          <tfoot>
            <tr *ngIf="lstProspects?.length == 0">
              <td colspan="9" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>

